import Meridian from './Meridian';
import County from './County';
import Tag from './Tag';
import Section from './Section';

export default class Township {
    id: number;
    projectId: number;
    townshipNumber: number;
    townshipCardinal: string;
    rangeNumber: number;
    rangeCardinal: string;
    meridian?: Meridian;
    sectionCount: number;
    block: string;
    counties: Array<County>;
    addCounties: Array<County>;
    deleteCounties: Array<County>;
    tags: Array<Tag>;
    addTags: Array<Tag>;
    deleteTags: Array<Tag>;
    sections: Array<Section>;

    // not mapped
    reportName: string;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/Township.ts